import Splide from '@splidejs/splide';

( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.category-slider-categories' ).each( ( key, element ) => {
        const slider = new Splide( element, {
          type: 'slide',
          perPage: 6,
          arrows: false,
          pagination: false,
          perMove: 1,
          breakpoints: {
            640: {
              perPage: 2,
            },
            786: {
              perPage: 3,
            },
            1270: {
              perPage: 4,
            },
          },
        } ).mount();

        const prevButton = element.closest( '.categories-slider' ).querySelector( '.category-slider-nav-prev' );
        const nextButton = element.closest( '.categories-slider' ).querySelector( '.category-slider-nav-next' );

        const updateButtonStates = () => {
          const currentIndex = slider.index;
          const firstIndex = 0;
          const lastIndex = slider.Components.Controller.getEnd();

          prevButton.classList.toggle( 'is-disabled', currentIndex === firstIndex );
          nextButton.classList.toggle( 'is-disabled', currentIndex === lastIndex );
        };

        updateButtonStates();

        prevButton.addEventListener( 'click', () => {
          slider.go( '<' );
        } );

        nextButton.addEventListener( 'click', () => {
          slider.go( '>' );
        } );

        slider.on( 'moved', updateButtonStates );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'categories-slider', COMPONENT );
} )( app );
